export const FETCH_PAYMENT_DATA_REQUEST = 'FETCH_PAYMENT_DATA_REQUEST';
export const FETCH_PAYMENT_DATA_SUCCESS = 'FETCH_PAYMENT_DATA_SUCCESS';
export const FETCH_PAYMENT_DATA_FAILURE = 'FETCH_PAYMENT_DATA_FAILURE';
